export default "__VITE_ASSET__CwosVnn3__"